export default __webpack_public_path__ + "static/media/21.e9b88158.png";